import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stepIndicator", "progressBar"]
  static values = { 
    appId: Number,
    currentStep: String
  }

  connect() {
    console.log("Installation Progress Controller connected")
  }

  navigateToStep(event) {
    const stepIndicator = event.currentTarget
    const stepName = stepIndicator.dataset.step
    
    // Don't navigate if clicking on current step
    if (stepName === this.currentStepValue) {
      return
    }
    
    // Show loading state
    this.showLoading(stepIndicator)
    
    // Navigate to the selected step
    const url = `/hl_app/installation_steps/${stepName}?app_id=${this.appIdValue}`
    
    window.location.href = url
  }



  showLoading(stepIndicator) {
    // Add loading class
    stepIndicator.classList.add('loading')
    
    // Show loading spinner
    const stepCircle = stepIndicator.querySelector('.step-circle')
    const originalContent = stepCircle.innerHTML
    stepCircle.innerHTML = '<i class="fas fa-spinner fa-spin"></i>'
    
    // Store original content for restoration
    stepIndicator.dataset.originalContent = originalContent
  }



  // Method to restore step indicator after navigation
  restoreStepIndicator() {
    this.stepIndicatorTargets.forEach(indicator => {
      if (indicator.dataset.originalContent) {
        const stepCircle = indicator.querySelector('.step-circle')
        stepCircle.innerHTML = indicator.dataset.originalContent
        indicator.classList.remove('loading')
        delete indicator.dataset.originalContent
      }
    })
  }
} 